<template>
  <div class="form-group mt-3">
    <label class="form-control-placeholder" :for="id">
      {{ config.Label }}
      <span v-if="config.Validation.required">*</span>
      <InfoText
        v-if="config.Info"
        :content="config.Info"
        :id="id"
        context="textarea"
      />
    </label>
    <textarea
      ref="item"
      :type="config.InputType"
      :name="id"
      :data-vv-as="config.ErrorMessage"
      v-validate="config.Validation"
      :id="'input' + id"
      class="form-control"
      :value="value"
      :required="config.Validation.required"
      @input="update()"
      @change="doChange()"
      @blur="update()"
    />
    <div class="invalid-feedback" ref="error">{{ errors.first(id) }}</div>
  </div>
</template>

<script>
  import InfoText from '@/components/base/InfoText';

  export default {
    components: { InfoText },
    props: ['value', 'id', 'config'],
    inject: {
      $validator: '$validator',
    },
    data() {
      return {
        showInput: false,
        innerValue: 0,
      };
    },
    methods: {
      update() {
        // check if valid
        if (this.value || this.$refs.item.value) {
          this.showInput = true;
        } else {
          this.showInput = false;
        }
        this.innerValue = this.$refs.item.value;
        this.$emit('input', this.$refs.item.value);
      },
      doChange() {
        this.$refs.error.style.display = 'block';
        this.$emit('getNewData');
      },
    },
    mounted() {
      if (this.value) {
        this.showInput = true;
      } else {
        this.showInput = false;
      }
    },
  };
</script>
<style lang="scss" scoped>
  label {
    position: relative;
    width: 100%;
    top: 0;

    /deep/ .infotext {
      bottom: 0;
    }
  }

  textarea {
    border: 1px solid $blue60;
    padding: 10px;
    height: 140px;
    resize: none;

    &:focus {
      border-color: $blue60;
    }
  }
</style>
